import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import OfferPage from './OfferPage';
import { PARTNERS } from '@/lib/partners';

const AFFILIATE_REF_KEY = 'hj_affiliate_ref';   // same key lib/marketing reads at checkout

/**
 * /<partner> (e.g. /limelite): the partner's co-branded version of /offer.
 * Landing here credits the partner the same way their ?ref= link does: first
 * touch, so a visitor who already arrived through another referral link keeps
 * that one. Set during the first render, before OfferPage fetches the offer
 * status, so the status comes back with the partner on it.
 */
const PartnerOfferPage: React.FC<{ partner: string }> = ({ partner }) => {
  const brand = PARTNERS[partner.toLowerCase()];
  useState(() => {
    if (!brand) return null;
    try { if (!localStorage.getItem(AFFILIATE_REF_KEY)) localStorage.setItem(AFFILIATE_REF_KEY, brand.code); } catch { /* storage off: still shows, just not credited */ }
    return null;
  });
  if (!brand) return <Navigate to="/offer" replace />;
  return <OfferPage brand={brand} />;
};

export default PartnerOfferPage;
